import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';


const getFilesCount = (dpsID) => {
  return axios.get(
    `/api/dps/${dpsID}/files/count`
  );
};

export const useFilesCount = (dpsID, options = {}) => {
  return useQuery(
    `dps-${dpsID}-count`,
    () => getFilesCount(dpsID),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
};